import { forwardRef } from "react";
import { useId } from "react";
function SvgHandOptimizedRawReadAloudGraphicLarge(
  { title, titleId, ...props },
  ref,
) {
  const id = useId();
  const toAppend = "_" + id;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={700}
      height={40}
      fill="none"
      aria-hidden="true"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <mask
        id={`HandOptimizedRawReadAloudGraphicLarge_svg__b${toAppend}`}
        width={700}
        height={40}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <rect
          width={4}
          height={6}
          x={264}
          y={17}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={6}
          x={648}
          y={17}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect width={4} height={4} x={256} y={18} fill="#fff" rx={2} />
        <rect
          width={4}
          height={4}
          x={640}
          y={18}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={10}
          x={248}
          y={15}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={10}
          x={632}
          y={15}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={14}
          x={240}
          y={13}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={14}
          x={624}
          y={13}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={14}
          x={456}
          y={13}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={18}
          x={232}
          y={11}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={18}
          x={616}
          y={11}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={18}
          x={448}
          y={11}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={18}
          x={480}
          y={11}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={24}
          x={488}
          y={8}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={30}
          x={496}
          y={5}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={36}
          x={504}
          y={2}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={26}
          x={224}
          y={7}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={26}
          x={608}
          y={7}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={26}
          x={440}
          y={7}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={26}
          x={472}
          y={7}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={30}
          x={216}
          y={5}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={30}
          x={600}
          y={5}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={30}
          x={432}
          y={5}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={20}
          x={464}
          y={10}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={34}
          x={208}
          y={3}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={34}
          x={592}
          y={3}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={34}
          x={424}
          y={3}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={30}
          x={200}
          y={5}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={30}
          x={584}
          y={5}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={30}
          x={416}
          y={5}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={40}
          x={192}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={40}
          x={576}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={40}
          x={408}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={40}
          x={184}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={40}
          x={568}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={40}
          x={320}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={36}
          x={552}
          y={2}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={40}
          x={328}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={40}
          x={560}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={40}
          x={336}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={40}
          x={344}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={40}
          x={352}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={32}
          x={360}
          y={4}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={38}
          x={368}
          y={1}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={32}
          x={376}
          y={4}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={40}
          x={384}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={40}
          x={392}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={40}
          x={400}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={34}
          x={176}
          y={3}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={34}
          x={312}
          y={3}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={26}
          x={544}
          y={7}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={30}
          x={168}
          y={5}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={30}
          x={304}
          y={5}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={16}
          x={688}
          y={12}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={6}
          x={696}
          y={17}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={14}
          x={536}
          y={13}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={30}
          x={160}
          y={5}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={30}
          x={296}
          y={5}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={28}
          x={680}
          y={6}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={6}
          x={528}
          y={17}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={24}
          x={152}
          y={8}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={23}
          x={288}
          y={8}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={24}
          x={672}
          y={8}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={12}
          x={520}
          y={14}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={18}
          x={144}
          y={11}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={18}
          x={280}
          y={11}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={18}
          x={664}
          y={11}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={26}
          x={512}
          y={7}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={10}
          x={136}
          y={15}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={10}
          x={272}
          y={15}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={10}
          x={656}
          y={15}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={8}
          x={128}
          y={16}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={10}
          x={120}
          y={15}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={16}
          x={112}
          y={12}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={22}
          x={104}
          y={9}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={10}
          x={96}
          y={15}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={10}
          x={88}
          y={15}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={18}
          x={80}
          y={11}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={10}
          x={72}
          y={15}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={14}
          x={64}
          y={13}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={10}
          x={56}
          y={15}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={8}
          x={48}
          y={16}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={6}
          x={40}
          y={17}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={2}
          x={32}
          y={19}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={1}
        />
        <rect
          width={4}
          height={4}
          x={24}
          y={18}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={4}
          x={16}
          y={18}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={4}
          x={8}
          y={18}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
        <rect
          width={4}
          height={6}
          y={17}
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend})`}
          rx={2}
        />
      </mask>
      <g mask={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__b${toAppend})`}>
        <path
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__c${toAppend})`}
          d="M0 0h700v40H0z"
        />
        <path
          fill={`url(#HandOptimizedRawReadAloudGraphicLarge_svg__d${toAppend})`}
          d="M0 0h700v40H0V0Z"
        />
      </g>
      <defs>
        <radialGradient
          id={`HandOptimizedRawReadAloudGraphicLarge_svg__c${toAppend}`}
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(-474.77024 11.31295 -2.35204 -98.70788 694.495 12.93)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.141} stopColor="#106FF3" />
          <stop offset={1} stopColor="#106FF3" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id={`HandOptimizedRawReadAloudGraphicLarge_svg__d${toAppend}`}
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(624.65673 -13.8384 1.44814 65.36806 38.646 26.768)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.197} stopColor="#643DFF" />
          <stop offset={0.384} stopColor="#7B3DFF" stopOpacity={0.38} />
          <stop offset={0.598} stopColor="#25C09B" stopOpacity={0.32} />
        </radialGradient>
        <linearGradient
          id={`HandOptimizedRawReadAloudGraphicLarge_svg__a${toAppend}`}
          gradientTransform="rotate(90)"
        >
          <stop stopColor="#fff" />
          <stop offset="50%" stopColor="#fff" />
          <stop offset="50%" stopColor="#fff" stopOpacity={0.62} />
          <stop offset="100%" stopColor="#fff" stopOpacity={0} />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgHandOptimizedRawReadAloudGraphicLarge);
export default ForwardRef;
